import * as React from "react";
import { SVGProps } from "react";
function SvgHideExpandedBigIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.146 8.854a.5.5 0 0 1 .708 0l3.97 3.97a.25.25 0 0 0 .353 0l3.97-3.97a.5.5 0 0 1 .707 0l.793.793a.5.5 0 0 1 0 .707l-5.293 5.293a.5.5 0 0 1-.708 0l-5.292-5.293a.5.5 0 0 1 0-.707l.792-.793Z"
        fill="#000"
      />
    </svg>
  );
}
export default SvgHideExpandedBigIcon;
